// Same fields the "Full mailing address" popup fills (see handlePasteAddressModal in shipment.js).
export const applyScannedAddress = (shipmentObject, type, address) => {
  const prefix = type === "sender" ? "f" : "s";
  return {
    ...shipmentObject,
    [`${prefix}Name`]: address?.name || "",
    [`${prefix}Add1`]: address?.addressLine1 || "",
    [`${prefix}Add2`]: address?.addressLine2 || "",
    [`${prefix}City`]: address?.city || "",
    [`${prefix}Postcode`]: address?.zip || "",
    [`${prefix}State`]: address?.state || "",
  };
};

export const formatScannedAddress = (address) =>
  [
    address?.name,
    address?.addressLine1,
    address?.addressLine2,
    [address?.city, [address?.state, address?.zip].filter(Boolean).join(" ")].filter(Boolean).join(", "),
  ]
    .filter(Boolean)
    .join(", ");
